import type { EnvMode } from '@be-link/cos';
import { Card, Input, Radio, Select, Space, Typography } from 'antd';
import {
	ENV_OPTIONS,
	PROJECT_OPTIONS,
	type ProjectType,
} from '../hooks/useFileUpload';

const { Text } = Typography;

interface UploadConfigProps {
	env: EnvMode;
	project: ProjectType;
	basePath: string;
	onEnvChange: (env: EnvMode) => void;
	onProjectChange: (project: ProjectType) => void;
}

export function UploadConfig({
	env,
	project,
	basePath,
	onEnvChange,
	onProjectChange,
}: UploadConfigProps) {
	return (
		<Card title="上传配置" style={{ marginBottom: 24 }}>
			<Space direction="vertical" size="middle" style={{ width: '100%' }}>
				<div>
					<Text strong>环境选择：</Text>
					<Radio.Group
						value={env}
						onChange={(e) => onEnvChange(e.target.value)}
						options={ENV_OPTIONS}
						style={{ marginLeft: 8 }}
					/>
				</div>

				<div>
					<Text strong>项目选择：</Text>
					<Select
						value={project}
						onChange={onProjectChange}
						options={PROJECT_OPTIONS.map(({ label, value }) => ({
							label,
							value,
						}))}
						style={{ marginLeft: 8, width: 200 }}
					/>
				</div>

				<div>
					<Text strong>上传路径：</Text>
					<Input
						value={basePath}
						disabled
						style={{ marginLeft: 8, width: 300, backgroundColor: '#fafafa' }}
					/>
				</div>
			</Space>
		</Card>
	);
}
